export {DialogBase} from './DialogBase';
export {Dialog as default} from './Dialog';
export {withDialog} from './withDialog';
